import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  min-width: 1200px;
  flex-grow: 1;
  height: 100%;
  overflow: visible;

  .main-wrapper {
    width: 100%;
    height: 100%;
  }

  .filter-and-lock-wrapper {
    display: flex;
    justify-content: end;
    align-items: center;
    margin-bottom: ${({ theme: { token } }) => token.margin}px;
    padding: 0 ${({ theme: { token } }) => token.padding}px;
    gap: ${({ theme: { token } }) => token.marginXS}px;
  }

  .filter-wrapper {
    display: flex;
    align-items: center;
  }

  .tier-lock-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .assets-grid {
    width: 100%;
    max-height: 50vh;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fill, 400px);
    grid-auto-rows: min-content;
    gap: ${({ theme: { token } }) => token.marginLG}px;
    padding-top: ${({ theme: { token } }) => token.marginXS}px;
  }
`;

